<template>
  <div class="givingCredits">
      <nav-bar :titleText="title" fontColor="#333333" @goBack="goBack"></nav-bar>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="givingCredits_content">
           <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad" style="min-height: 42%;">
          <!-- <div class="givingCredits_item">
            <div class="content_title">这里是店铺名称店铺名称店铺名称店铺名称 这里是店铺名称这里</div>
            <div class="content_item">
                <span class="content_itemleft">剩余赠送金额</span>
                <span class="content_itemright lose">¥3410.00</span>
            </div>
            <div class="content_tip">温馨提示：由于店铺下架，该额度已失效</div>
            <img class="loseimg" src="../../assets/shared-hotel/lose.png" alt=""/>
          </div> -->
          <div class="givingCredits_item" v-for="(item, i) in list" :key="i">
            <div class="content_title">{{item.shop.shop_name}}</div>
            <div class="content_item">
                <span class="content_itemleft">剩余赠送金额</span>
                <span :class="item.invalid_status==0?'content_itemright lose':'content_itemright'">¥{{item.award_amount}}</span>
            </div>
            <div class="content_tip" v-if="item.invalid_status==0">温馨提示：{{item.invalid_comment}}</div>
            <img class="loseimg" src="../../assets/shared-hotel/lose.png" alt="" v-if="item.invalid_status==0"/>
          </div>
          </van-list>
        <div class="empty" v-if="list.length === 0">
            <img src="../../assets/shared-hotel/empty.png" alt="">
            <p>暂无结果</p>
        </div>
      </div>
      </van-pull-refresh>
  </div>
</template>

<script>
import navBar from './components/navBar'
export default {
    name:'givingCredits',
    data(){
        return{
            title:'赠送额度',
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            page: 0,
            pageSize:10,
        }
    },
    components:{
        navBar,
    },
    computed: {
        finishedText(){
        if (this.list.length && ! this.loading && ! this.refreshing) {
            return '- 没有更多了 -'
        }
        return ''
        },
    },
    methods:{
        onLoad() {
            this.getRecordList();
        },
        onRefresh() {
            this.page = 0;
            this.onLoad();
        },
        getRecordList() {
            this.page ++
            let params = { 
                page: this.page,
                pageSize:this.pageSize,
            }
            
            this.$api.get("/offshop/member/canteen/membership-card/award-list", params).then((res) => {
                let _list = res.list
                if (this.refreshing) {
                this.list = [];
                this.finished = false;
                }

                this.list.push(..._list)

                if (this.list.length === 0 || _list.length === 0) {
                this.finished = true;
                this.loading = false;
                this.refreshing = false;
                return;
                }

                this.loading = false;

                if (res.current_page == res.last_page) {// 数据全部加载完成
                this.finished = true;
                }

                if (this.refreshing) {
                this.$toast("刷新成功");
                this.refreshing = false;
                }

                if (! this.finished && ! this.loading && this.list.length <= 4) {
                this.onLoad()
                }
                
            })
            .catch(()=>{
                this.loading = false;
                this.refreshing = false;
                this.finished = true
            })
        },
         goBack() {
            this.$router.go(-1)
        }, 
    }
}
</script>

<style lang="less" scoped>
.givingCredits{
    background: #F5F6F7;
    height: 100%;
    overflow: auto;
    padding-top: 88px;
    box-sizing: border-box;
    .givingCredits_content{
        padding: 0 12px;
        box-sizing: border-box;
        .givingCredits_item{
            margin-top: 10px;
            background: #FFFFFF;
            border-radius: 6px;
            padding: 15px 20px;
            box-sizing: border-box;
            position: relative;
            .loseimg{
                position: absolute;
                top:0px;
                right: 0px;
                width: 42px;
            }
            .content_title{
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                margin-bottom: 10px;
            }
            .content_item{
                display: flex;
                .content_itemleft{
                    flex: 1;
                    font-size: 16px;
                    font-weight: 400;
                    color: #999999;
                }
                .content_itemright{
                    flex: 1;
                    font-size: 18px;
                    font-weight: 600;
                    color: #333333;
                    text-align: right;
                }
                .lose{
                    color: #999999;
                }
            }
            .content_tip{
                margin-top: 8px;
                background: rgba(249,89,27,0.09);
                border-radius: 3px;
                padding: 5px 10px;
                box-sizing: border-box;
                font-size: 15px;
                font-weight: 400;
                color: #f54d0c;
            }
        }
        .empty {
            width: 100%;
            img {
            width: 100%;
            padding: 105px 47px 19px;
            box-sizing: border-box;
            }
            p:nth-of-type(1) {
            width: 100%;
            text-align: center;
            font-size: 15px;
            color: #999999;
            }
        }
    }
}
</style>